import { useEffect, useState } from 'react'
import { customersApi, salesApi } from '../../services/api'
import LocationsMaps from '../../components/LocationsMaps'

export default function RoutesPage() {
  const [customers, setCustomers] = useState<any[]>([])
  const [sales, setSales] = useState<any[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [customersRes, salesRes] = await Promise.all([
          customersApi.list(),
          salesApi.list(),
        ])
        setCustomers(customersRes.data.customers || [])
        setSales(salesRes.data.sales || [])
      } catch (error) {
        console.error('Error fetching data:', error)
      } finally {
        setLoading(false)
      }
    }
    fetchData()
  }, [])

  if (loading) {
    return <div className="text-center py-8">Cargando...</div>
  }

  return (
    <div>
      <h1 className="text-2xl font-bold text-espresso-800 mb-6">Mapa de Ubicaciones</h1>
      <LocationsMaps customers={customers} sales={sales} />
    </div>
  )
}
